module.exports = __webpack_public_path__ + "static/fonts/fa-v4compatibility.38fec63.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/webfonts/fa-v4compatibility.ttf
// module id = ZJAw
// module chunks = 2